// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__3B819","normal":"Index_normal__Gsd7X","normalH5":"Index_normalH5__Wgba6","animationFade":"Index_animationFade__31eBW"};